<div class="wrapper">
  <div class="wrapper__client-name-wrapper">
    <a [routerLink]="'/edit-form/' + clientId">
    <h2 class="wrapper__client-name" [matTooltip]="clientName" matTooltipPosition="right">
      {{clientName}}
    </h2>
    </a>
  </div>
  <nav class="side-menu">
    <mat-accordion multi="true">
      <mat-expansion-panel
        #panel
        *ngFor="let menuItem of menu; let i = index"
        [ngClass]="{ 'selected-panel': selectedIndex === i }">

        <mat-expansion-panel-header (click)="onStepChange(i, panel)">
          <mat-panel-title>
            <div class="panel-title-content">
              <mat-icon>{{ getMatIcon(menuItem.icon) }}</mat-icon>
              <strong>{{ menuItem.name }}</strong>
            </div>
          </mat-panel-title>
          <mat-panel-description class="hide-toggle-icon"></mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Submenu -->
        <div class="submenu" *ngIf="menuItem.children?.length">
          <ng-container *ngFor="let child of menuItem.children">
            <button mat-button
              *ngIf="!child.children"
              [routerLink]="child.isAbsoluteRoute ? child.route : '/pluton-invoicing/' + child.route"
              [queryParams]="child.queryParams"
              [routerLinkActiveOptions]="{exact: true}"
              [routerLinkActive]="'active-substep'"
              [ngClass]="{ 'active-substep': isActiveRoute(child.isAbsoluteRoute ? child.route : '/pluton-invoicing' + child.route) }"
              (click)="onSubStepClick(i, child.name, $event)">
              <mat-icon>{{ getMatIcon(child.icon) }}</mat-icon>
              {{ child.name }}
            </button>

            <!-- Nested submenu for items with children -->
            <div *ngIf="child.children" class="nested-submenu">
              <button mat-button
                class="submenu-parent"
                (click)="toggleNestedMenu(child.name)">
                <mat-icon>{{ getMatIcon(child.icon) }}</mat-icon>
                {{ child.name }}
                <mat-icon class="arrow-icon" [ngClass]="{'expanded': expandedNestedMenu === child.name}">
                  chevron_right
                </mat-icon>
              </button>

              <div class="nested-items" *ngIf="expandedNestedMenu === child.name">
                <button mat-button
                  *ngFor="let subChild of child.children"
                  [routerLink]="'/invoicing/' + subChild.route"
                  [routerLinkActiveOptions]="{exact: true}"
                  [routerLinkActive]="'active-substep'"
                  class="nested-item">
                  <mat-icon>{{ getMatIcon(subChild.icon) }}</mat-icon>
                  {{ subChild.name }}
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </nav>
</div>
